import { connect } from 'react-redux';
import React, { useCallback, useEffect, useState } from 'react';
import { default as __ } from '../../../utils';
import { UserPalaWithState } from '../../../components/padel/pala';
import { useCustomizer } from './context';
const { count } = React.Children;

const useSlider = props => {
  const [step, setStep] = useState(props.initial);
  function next() {
    if (step === count(props.children) - 1) {
      __.sleep(30).then(() => setStep(props.initial));
    } else {
      __.sleep(30).then(() => setStep(step => step + 1));
    }
  }
  function previous() {
    if (step > 0) {
      __.sleep(30).then(() => setStep(step => step - 1));
    }
  }
  //   useEffect(() => {
  //   }, [step]);

  const slideTo = {
    next: useCallback(_ => next()),
    previous: useCallback(_ => previous()),
  };

  return [step, slideTo];
};

let stylesBar = {
  container: {
    width: ' 100%',
    border: ' 1px solid var(--accent)',
    position: 'relative',
    cursor: 'pointer',
  },
  button: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    height: '100px',
    zIndex: 99,
  },
  next: {
    right: '6px',
  },
  previous: {
    left: '6px',
  },
};

const ConnectedPala = ({ user, cb = __.noop(), initial = 0 }) => {
  const { palas } = user;
  const [step, slideTo] = useSlider({ initial: user.palas[user.palas.length - 1].id });
  const { state, actions } = useCustomizer();

  const update = pala => {
    actions.updateSlice('pala', pala);
  };

  useEffect(() => {
    actions.updateSlice('pala', __.unwrapIterable(palas));
  }, []);

  return (
    <>
      <div style={{ ...stylesBar.container }}>
        {step !== 0 && (
          <button
            type="button"
            className="io-unbutton"
            style={{ ...stylesBar.button, ...stylesBar.previous }}
            onClick={slideTo.previous}
          >
            <svg width="60" height="100" viewBox={'0 -22 100 140'}>
              <path
                fill="var(--accent)"
                d="M7.647 51.378l38.87 38.856a4.378 4.378 0 0 0 6.178 0 4.355 4.355 0 0 0 0-6.165L16.91 48.295l35.782-35.773a4.36 4.36 0 0 0 0-6.17 4.378 4.378 0 0 0-6.179 0L7.643 45.208c-1.675 1.684-1.675 4.49.004 6.17z"
              />
            </svg>
          </button>
        )}

        {palas.reverse().map(p => (
          <Step key={p.id} isActive={p.id === step}>
            <UserPalaWithState
              {...p}
              isActive={state.pala.id === p.id}
              cb={() => update(p)}
            />
          </Step>
        ))}

        {step < palas.length - 1 && (
          <button
            type="button"
            className="io-unbutton"
            style={{ ...stylesBar.button, ...stylesBar.next }}
            onClick={slideTo.next}
          >
            <svg width="60" height="100" viewBox={'-40 -24 100 140'}>
              <path
                fill="var(--accent)"
                d="M52.714 45.208L13.844 6.352a4.378 4.378 0 0 0-6.178 0 4.355 4.355 0 0 0 0 6.166L43.452 48.29 7.67 84.064a4.36 4.36 0 0 0 0 6.17 4.378 4.378 0 0 0 6.18 0l38.868-38.856c1.676-1.684 1.676-4.49-.004-6.17z"
              />
            </svg>
          </button>
        )}
      </div>
    </>
  );
};

// palas.filter(p=> p.id === step).map( p => <UserPalaWithState key={p.id} {...p} cb={()=> submit(p.id)} />)

const select = state => {
  return {
    user: state.session.user,
  };
};

const PalaBar = connect(select, null)(ConnectedPala);

export default PalaBar;

function Step({ isActive, children }) {
  return isActive ? <div pala-widget-slider="step">{children}</div> : null;
}
